import SalesChannel from "./SalesChannel";

export default SalesChannel;
